import { QuestelServicesClient, RequestResult, HttpMethodEnum } from '@questelservices/common';
import store from '@/store';
import { LoadOptions } from 'devextreme/data/load_options';
import { CommentDto } from '@/models/comments/CommentDto';
import { EmailResponseDto } from '@/models/comments/EmailResponseDto';
import { RespondEnum } from '@/models/comments/RespondEnum';
import { CommentEmailDto } from '@/models/comments/CommentEmailDto';

export class CommentService {
  private readonly client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, '/api/comments');
  }

  async search(options: LoadOptions) : Promise<any> {
    return await this.client.getPostData(`/search`, options);
  }

  async searchAll(options: LoadOptions) : Promise<any> {
    return await this.client.getPostData(`/search-all`, options);
  }

  async searchCommentEmail(options: LoadOptions) : Promise<any> {
    return await this.client.getPostData(`/search-comment-email`, options);
  }

  async edit(id: Guid, data: CommentDto) : Promise<RequestResult> {
    return await this.client.sendRequest(HttpMethodEnum.Put, `/${id}`, data);
  }

  async editCommentEmail(id: Guid, data: CommentEmailDto) : Promise<RequestResult> {
    return await this.client.sendRequest(HttpMethodEnum.Put, `/update-email/${id}`, data);
  }

  async getCanEscalate(): Promise<boolean> {
    return await this.client.getData(HttpMethodEnum.Get, `/can-escalate`);
  }

  public async sendEmail(data: EmailResponseDto,responseType : RespondEnum): Promise<any> {
    return await this.client.postJson(`/send-email-response?responseType=${responseType}`, data);
  }

  public async getResponseHistory(emailId: Guid): Promise<any> {
    return await this.client.getData(HttpMethodEnum.Get, `/response-history/${emailId}`);
  }

}
